<table class="table">
  <thead>
  <tr>
    @for (item of header; track $index) {
      <th> {{ item }}</th>
    }
  </tr>
  </thead>
  <tbody>
    @for (item of body.filter; track $index) {
      <tr>
        @for (subItem of item; track $index) {
          <td> {{ subItem }}</td>
        }
      </tr>
    }
  </tbody>
</table>
